import { ManureOfferModel } from 'src/app/offer/models/manure-offer.model';
import { ManureRequestModel } from 'src/app/request/models/manure-request.model';
import { ManureFilters } from 'src/app/shared/models/manure-filters.model';

import { PageAndSize } from './paginated-overview.model';

export interface OverviewState {
  offerOverviewList?: ManureOfferModel[];
  requestsOverviewList?: ManureRequestModel[];
  selectionButton: 'offers' | 'requests';
  totalNumberOfOffers: number;
  totalNumberOfRequests: number;
  status: 'error' | 'success' | 'pending' | 'loading';
  offerPageAndSize: PageAndSize;
  requestsPageAndSize: PageAndSize;
  currentTab: Tabs;
  filters: ManureFilters;
  overviewOffersLoading: boolean;
  overviewRequestsLoading: boolean;
}

export interface OrderOptions {
  column: string;
  descending: boolean;
}

export enum Tabs {
  manureOffers = 'MANURE_OFFERS',
  manureRequests = 'MANURE_REQUESTS',
}

export interface OfferOverviewModel extends ManureOfferModel {
  maxNitrogen?: number;
  maxPhosphate?: number;
  totalPrice: number;
  customerName?: string;
  contactInformation?: string;
  shipToAddress?: string;
}

export interface RequestsOverviewModel extends ManureRequestModel {
  maxNitrogen?: number;
  maxPhosphate?: number;
  totalPrice: number;
  customerName?: string;
  contactInformation?: string;
  shipToAddress?: string;
}

export enum OffersColumnTypes {
  customerName = 'customerName',
  shipToAddress = 'shipToAddress',
  contactInformation = 'contactInformation',
  manureCategory = 'manureCategory',
  manureType = 'manureType',
  amountInTons = 'amountInTons',
  nKgPerTon = 'nKgPerTon',
  maxNitrogen = 'maxNitrogen',
  pKgPerTon = 'pKgPerTon',
  maxPhosphate = 'maxPhosphate',
  kKgPerTon = 'kKgPerTon',
  isHomogeneous = 'isHomogeneous',
  distance = 'distance',
  maxDistance = 'maxDistance',
  desiredDeliveryPeriod = 'desiredDeliveryPeriod',
  paymentType = 'paymentType',
  pricePerTon = 'pricePerTon',
  totalPrice = 'totalPrice',
  status = 'status',
}

export enum RequestsColumnTypes {
  customerName = 'customerName',
  shipToAddress = 'shipToAddress',
  contactInformation = 'contactInformation',
  manureCategory = 'manureCategory',
  manureType = 'manureType',
  amountInTons = 'amountInTons',
  nKgPerTon = 'nKgPerTon',
  maxNitrogen = 'maxNitrogen',
  pKgPerTon = 'pKgPerTon',
  maxPhosphate = 'maxPhosphate',
  kKgPerTon = 'kKgPerTon',
  isHomogeneous = 'isHomogeneous',
  distance = 'distance',
  maxDistance = 'maxDistance',
  desiredDeliveryPeriod = 'desiredDeliveryPeriod',
  paymentType = 'paymentType',
  pricePerTon = 'pricePerTon',
  totalPrice = 'totalPrice',
  status = 'status',
  action = 'action',
}

export const offerDisplayColumns = [
  OffersColumnTypes.manureCategory,
  OffersColumnTypes.manureType,
  OffersColumnTypes.amountInTons,
  OffersColumnTypes.nKgPerTon,
  OffersColumnTypes.maxNitrogen,
  OffersColumnTypes.pKgPerTon,
  OffersColumnTypes.maxPhosphate,
  OffersColumnTypes.kKgPerTon,
  OffersColumnTypes.isHomogeneous,
  OffersColumnTypes.distance,
  OffersColumnTypes.desiredDeliveryPeriod,
  OffersColumnTypes.paymentType,
  OffersColumnTypes.pricePerTon,
  OffersColumnTypes.totalPrice,
  OffersColumnTypes.status,
] as const;

export const requestDisplayColumns = [
  RequestsColumnTypes.manureCategory,
  RequestsColumnTypes.manureType,
  RequestsColumnTypes.amountInTons,
  RequestsColumnTypes.nKgPerTon,
  RequestsColumnTypes.maxNitrogen,
  RequestsColumnTypes.pKgPerTon,
  RequestsColumnTypes.maxPhosphate,
  RequestsColumnTypes.kKgPerTon,
  RequestsColumnTypes.isHomogeneous,
  RequestsColumnTypes.distance,
  RequestsColumnTypes.desiredDeliveryPeriod,
  RequestsColumnTypes.paymentType,
  RequestsColumnTypes.pricePerTon,
  RequestsColumnTypes.totalPrice,
  RequestsColumnTypes.status,
] as const;
